import {
    Layout,
    Button,
    Page,
    Frame,
    LegacyStack, Card, Tabs, BlockStack,
} from '@shopify/polaris';

import {useCallback, useEffect, useState} from 'react';
import OrdersSearch from "./OrdersSearch";
import Api from "../../helpers/api";

const OrdersList = () => {
    const [searchType, setSearchType] = useState('sales_rep');
    const [tabIndex, setTabIndex] = useState(0);
    const [loading, setLoading] = useState(false);
    const [exportModalActive, setExportModalActive] = useState(false);
    const [user, setUser] = useState();

    useEffect(() => {
        Api
            .getMe()
            .then(({data}) => {
                setUser(data.user);
            })
    }, []);

    useEffect(() => {
        setSearchType(tabs[tabIndex].id);
    }, [tabIndex]);

    const primaryAction = useCallback(() => {
        return {content: "Shipping Export", onAction: () => setExportModalActive(true)};
    }, [user]);

    const tabs = [
        {
            id: 'sales_rep',
            content: 'My Orders',
        },
        {
            id: 'sales_rep_company',
            content: 'My Companies\' Orders',
        }
    ];

    return (
        <Frame>
            <Page title="Orders" primaryAction={primaryAction()} fullWidth>

                <BlockStack gap={'400'}>
                    <Tabs tabs={tabs} selected={tabIndex} onSelect={setTabIndex} />

                    <OrdersSearch
                        searchType={searchType}
                        loading={loading}
                        setLoading={setLoading}
                        exportModalActive={exportModalActive}
                        setExportModalActive={setExportModalActive}
                    />
                </BlockStack>
            </Page>
        </Frame>
    );
}

export default OrdersList;
